import FiltersButton from '../../../common/components/FiltersButton.js'
import {
  deleteFilterConfig,
  NEW_FILTER_CONFIG_ID,
} from '../../../data/filterConfigs.js'
import {hasOrderManageFilterConfigPermissionSelector} from '../../../data/me.js'
import {useSelector} from '../../../store.js'
import {
  showOrderListFilterConfigModal,
  showOrderListFilterModal,
} from '../Modals/OrderListFilterModal/orderListFilterModalFunctions.js'
import {navigateToOrderListFromFilterConfig} from '../orderListActions.js'
import {orderListQueryParamsSelector} from '../orderListSelectors.js'

export default function OrderFilterControl() {
  const orderQuery = useSelector(orderListQueryParamsSelector)
  const hasOrderManageFilterConfigPermission = useSelector(
    hasOrderManageFilterConfigPermissionSelector,
  )

  return (
    <li className="wrap--filters-btn inline-block divider--left">
      <FiltersButton
        onClick={() => showOrderListFilterModal({query: orderQuery})}
        type="order"
        onFilterConfigCreate={() =>
          showOrderListFilterConfigModal({
            query: orderQuery,
            filterConfigID: NEW_FILTER_CONFIG_ID,
          })
        }
        onFilterConfigApply={(option) =>
          navigateToOrderListFromFilterConfig(option.entity.id)
        }
        onFilterConfigEdit={(option) =>
          showOrderListFilterConfigModal({
            filterConfigID: option.entity.id,
          })
        }
        onFilterConfigDelete={(option) => deleteFilterConfig(option.entity.id)}
        hasManageFilterConfigPermission={hasOrderManageFilterConfigPermission}
      />
    </li>
  )
}
